export default {
  pid: 'Id da publicação',
  username: 'Nome do usuário',
  posted_at: 'Data original do documento',
  processed_at: 'Data de importação',
  post_url: 'Url da publicação',
  openPostLabel: 'Abrir publicação',
  infoLabel: 'Informações do Componente',
  closeLabel: 'Fechar informações',
  faq1: {
    title: 'O que é ?',
    description: 'Componente com dados do histórico de importação',
  },
  faq2: {
    title: 'Quais dados temos disponíveis?',
    description: 'Usuário que importou, data do documento, data da importação e link do documento',
  },
  unavailableLink: 'Link indisponível',
  textToClipboard: 'Texto copiado para a área de transferência.',
  failedClipboard: 'Falha ao copiar o texto.',
};
